import { render } from "./CourseCard.vue?vue&type=template&id=5f847c28&scoped=true"
import script from "./CourseCard.vue?vue&type=script&lang=js"
export * from "./CourseCard.vue?vue&type=script&lang=js"

import "./CourseCard.vue?vue&type=style&index=0&id=5f847c28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f847c28"]])

export default __exports__